export default __webpack_public_path__ + "a3e412cbed3296e8a5add0cc5727df5d.jpg";